module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-eofy-mobile.832cab49.jpg";